import React, { Dispatch, SetStateAction } from "react"
import { Icon, Info, OperationData, OperationType, OperationWrapper } from "./Shared.styled"
import OperationActions from "./OperationActions/OperationActions"
import dayjs from "dayjs"
import {
  OrderOperationSearchHit,
  OrderOperationSearchHits
} from "lib/types/generated/graphql-types"
import { ApolloQueryResult } from "@apollo/client"
import { Link } from "react-router-dom"
import { ReactComponent as DeliveryIcon } from "images/icons/truck-ramp-box.svg"
import { ReactComponent as RefundIcon } from "images/icons/arrows-repeat.svg"
import { ReactComponent as CancelIcon } from "images/icons/ban.svg"
import { ReactComponent as ReleaseIcon } from "images/icons/cart-arrow-up.svg"
import { ReactComponent as CompensationIcon } from "images/icons/hand-holding-dollar.svg"
import { ReactComponent as ModificationIcon } from "images/icons/pen-to-square.svg"
import { ReactComponent as CommentIcon } from "images/icons/comment-lines.svg"

type Props = {
  getStoreGroupName: (storeGroupId: string) => string | undefined
  operation: OrderOperationSearchHit
  refetchOperations: () => Promise<ApolloQueryResult<OrderOperationSearchHits>>
  pending: boolean | undefined
  setCreatedOperations: Dispatch<SetStateAction<OrderOperationSearchHit[]>>
  setFailedOperations: Dispatch<SetStateAction<OrderOperationSearchHit[]>>
}

const OperationRow = ({
  getStoreGroupName,
  operation,
  refetchOperations,
  pending,
  setCreatedOperations,
  setFailedOperations
}: Props) => {
  const [showEdit, setShowEdit] = React.useState<boolean>(false)

  const getOperationConfig = (operation: string) => {
    switch (operation) {
      case "Delivery":
        return { icon: <DeliveryIcon />, color: "#4A9F57", label: "Delivery"}
      case "Compensation":
        return { icon: <CompensationIcon />, color: "#6A1B9A", label: "Compensation" }
      case "Refund":
        return { icon: <RefundIcon />, color: "#1565C0", label: "Refund" }
      case "Release":
        return { icon: <ReleaseIcon />, color: "#2A8C88", label: "Release" }
      case "Cancellation":
        return { icon: <CancelIcon />, color: "#C62828", label: "Cancellation" }
      case "OrderLinesModification":
        return { icon: <ModificationIcon />, color: "#7E57C2", label: "Modification order lines" }
      case "ShippingFeesModification":
        return { icon: <ModificationIcon />, color: "#26A69A", label: "Modification shipping fees" }
      case "AddressesModification":
        return { icon: <ModificationIcon />, color: "#E67E22", label: "Modification addresses" }
    }
  }

  return (
    <OperationWrapper
      key={operation.id}
      $color={getOperationConfig(operation.type)?.color ?? ""}
    >
      {showEdit && (
        <OperationActions
          show={showEdit}
          setShow={setShowEdit}
          operation={operation}
          refetchOperations={refetchOperations}
          setCreatedOperations={setCreatedOperations}
          setFailedOperations={setFailedOperations}
          getOperationConfig={getOperationConfig}
        />
      )}
      <Info>
        <OperationType $color={getOperationConfig(operation.type)?.color ?? ""}>
          {getOperationConfig(operation.type)?.icon}
          <b>{getOperationConfig(operation.type)?.label}</b>
        </OperationType>
        <OperationData>
          {getStoreGroupName(operation.storeGroupId) ?? operation.storeGroupId}
        </OperationData>
        <OperationData >
          <b>Order ref: {operation.orderReference}</b>
        </OperationData>
        {operation.reason && (
          <OperationData>
            <CommentIcon />
            {operation.reason.code} - {operation.reason.cause}
          </OperationData>
        )}
        <OperationData>{dayjs(operation.created).format("YYYY-MM-DD HH:mm")} - {operation?.createdBy?.name}</OperationData>
      </Info>
      {pending ? (
        <Link to={`/orders/manage-order/${operation.orderId}`} target={"_blank"}>
          <Icon />
        </Link>
      ) : (
        <Icon onClick={() => setShowEdit(true)} />
      )}
    </OperationWrapper>
  )
}

export default OperationRow
